<template>
    <div class="vc-navigation-items">
        <a
            v-for="item of tab.subNav"
            :key="item.menuId"
            :href="`${item.url}?ref_=vc_xx_subNav`"
            :id="`vc-navigation-item-${item.menuId}`"
            class="vc-navigation-item"
            tabindex="0"
            @click="onClickNavItem(item)"
        >
            {{ item.text }}
            <div
                v-if="item.dataAttributes && item.dataAttributes.descriptionText"
                class="vc-navigation-item-description"
            >
                {{ item.dataAttributes.descriptionText }}
            </div>
        </a>
        <a
            v-if="showRedesignOptIn"
            class="vc-navigation-item vc-navigation-item-divider"
            data-test-tag="vc-navigation-item-redesign-opt-in"
            href="javascript:void(0)"
            tabindex="0"
            @click="onClickRedesignOptIn"
        >
            {{ $t('header_right_redesignOptIn') }}
        </a>
    </div>
</template>
<script>
import { RedesignPreference } from '../enums/RedesignPreference';
import { setRedesignPreference } from '../util/redesignPreference';

export default {
    name: 'NavigationItems',
    props: {
        tab: {
            type: Object,
            required: true,
        },
        showRedesignOptIn: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            openTime: null,
        };
    },
    methods: {
        onClickNavItem(item) {
            if (this.openTime) {
                const openDuration = Date.now() - this.openTime;
                this.$metrics
                    .newChildActionPublisherForMethod('RedesignImpression')
                    .publishTimerMonitor(`vc-navtab-${this.tab.menuId}.page-${item.menuId}.click`, openDuration);
                this.openTime = null; // Prevent the 'show' metric from also being logged
            }
            window.sessionStorage.setItem('nav-linked-from', `vc-navtab-${this.tab.menuId}=${window.ue_id}`);
            // Let the browser handle updating the page URL, since it supports opening new tabs or windows
        },
        onClickRedesignOptIn() {
            this.$metrics.newChildActionPublisherForMethod('RedesignNavOptIn').publishCounterMonitor('click', 1);
            this.openTime = null; // Prevent the 'show' metric from also being logged
            setRedesignPreference(RedesignPreference.optIn);
            window.location.reload();
        },
    },
    mounted() {
        this.openTime = Date.now();
    },
    unmounted() {
        if (this.openTime) {
            const openDuration = Date.now() - this.openTime;
            if (openDuration > 100) {
                this.$metrics
                    .newChildActionPublisherForMethod('RedesignImpression')
                    .publishTimerMonitor(`vc-navtab-${this.tab.menuId}.show`, openDuration);
            }
            this.openTime = null;
        }
    },
};
</script>
<style lang="scss">
.vc-navigation-items {
    background-color: white;
    border: 1px solid #d8d8d8;
    border-top: 0;
    box-shadow: 0 4px 4px rgb(0 0 0 / 30%);
    display: flex;
    flex-direction: column;
    left: 0;
    min-width: 225px;
    position: absolute;
    top: 30px;
    z-index: 200;

    a:hover {
        text-decoration: none;
    }
}

.vc-navigation-item {
    border: 1px solid white;
    color: #333 !important;
    font-size: 13px;
    line-height: 20px;
    padding: 5px 30px 5px 12px;
    text-decoration: none;

    &:first-child {
        margin-top: 6px;
    }

    &:focus,
    &:hover {
        background-color: #f9f9f9;
        border-color: #ebebeb #f9f9f9 #ebebeb #e47911;
    }

    &-description {
        color: #707070;
        font-size: 0.75em;
    }

    &-divider {
        border-top-color: #ebebeb;
    }
}
</style>
